var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#14B8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1849_3525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99989 4.44434C8.90111 4.44434 7.827 4.77016 6.91339 5.38062C5.99979 5.99107 5.28772 6.85873 4.86723 7.87387C4.44674 8.88902 4.33672 10.0061 4.55109 11.0837C4.76545 12.1614 5.29456 13.1513 6.07152 13.9283C6.84848 14.7052 7.83839 15.2343 8.91606 15.4487C9.99373 15.6631 11.1108 15.553 12.1259 15.1326C13.1411 14.7121 14.0087 14 14.6192 13.0864C15.2296 12.1728 15.5554 11.0987 15.5554 9.99989C15.5554 9.27033 15.4118 8.5479 15.1326 7.87387C14.8534 7.19984 14.4441 6.5874 13.9283 6.07152C13.4124 5.55564 12.7999 5.14642 12.1259 4.86723C11.4519 4.58803 10.7295 4.44434 9.99989 4.44434ZM9.99989 14.4443C9.12087 14.4443 8.26158 14.1837 7.53069 13.6953C6.79981 13.207 6.23015 12.5128 5.89376 11.7007C5.55737 10.8886 5.46936 9.99496 5.64085 9.13282C5.81234 8.27069 6.23563 7.47876 6.8572 6.85719C7.47876 6.23563 8.27069 5.81234 9.13283 5.64085C9.99496 5.46936 10.8886 5.55737 11.7007 5.89376C12.5128 6.23015 13.207 6.79981 13.6953 7.53069C14.1837 8.26158 14.4443 9.12086 14.4443 9.99989C14.4443 11.1786 13.9761 12.3091 13.1426 13.1426C12.3091 13.9761 11.1786 14.4443 9.99989 14.4443Z",
    fill: "#14B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0551 8.33279C10.3619 8.33279 10.6106 8.08406 10.6106 7.77724C10.6106 7.47041 10.3619 7.22168 10.0551 7.22168C9.74824 7.22168 9.49951 7.47041 9.49951 7.77724C9.49951 8.08406 9.74824 8.33279 10.0551 8.33279Z",
    fill: "#14B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0551 8.88867C9.90772 8.88867 9.76642 8.9472 9.66223 9.05139C9.55804 9.15558 9.49951 9.29688 9.49951 9.44423V12.222C9.49951 12.3693 9.55804 12.5107 9.66223 12.6148C9.76642 12.719 9.90772 12.7776 10.0551 12.7776C10.2024 12.7776 10.3437 12.719 10.4479 12.6148C10.5521 12.5107 10.6106 12.3693 10.6106 12.222V9.44423C10.6106 9.29688 10.5521 9.15558 10.4479 9.05139C10.3437 8.9472 10.2024 8.88867 10.0551 8.88867Z",
    fill: "#14B8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1849_3525",
    x: 0.444336,
    y: 0.444336,
    width: 19.1111,
    height: 19.1111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.843137 0 0 0 0 0.917647 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1849_3525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1849_3525",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6994f16802a404c4002dce8d926aea66.svg";
export { ForwardRef as ReactComponent };